var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"app"}},[_c('CharacterSelection',{on:{"items-loaded":_vm.updateItems}}),_c('AtlasProgress',{attrs:{"items":_vm.items,"mapCounts":_vm.mapCounts}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }